import { getEntityHeaders } from './activeEntity';

/** Same key as AuthContext (risklo_auth_token). */
const AUTH_TOKEN_KEY = 'risklo_auth_token';

/**
 * Bearer header for API routes that honor optional JWT (rate limits, auth checks).
 */
export function getBearerAuthHeaders() {
  if (typeof localStorage === 'undefined') return {};
  try {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    // Entity header rides along on every authed call so the server scopes data
    // to the brand the user is currently viewing.
    const entity = getEntityHeaders();
    return token ? { Authorization: `Bearer ${token}`, ...entity } : { ...entity };
  } catch {
    return {};
  }
}

/**
 * Headers for Vector Capital data APIs. When an admin previews a member tier,
 * send X-RiskLo-Admin-View-As so internal strategies are hidden like a real member.
 */
export function getVectorApiHeaders({ adminViewAs, isAdminActual } = {}) {
  const headers = { ...getBearerAuthHeaders() };
  if (isAdminActual && adminViewAs && adminViewAs !== 'admin') {
    headers['X-RiskLo-Admin-View-As'] = adminViewAs;
  }
  return headers;
}
